import { render, staticRenderFns } from "./ServicesParametersTab.vue?vue&type=template&id=05772b8e&"
import script from "./ServicesParametersTab.vue?vue&type=script&lang=js&"
export * from "./ServicesParametersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports